module.exports = __webpack_public_path__ + "static/media/yt-chase-brown.54406bf2.mov";